import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c54d6ec2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ModalPanel" }
const _hoisted_2 = { class: "content__header" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  key: 1,
  class: "header__title"
}
const _hoisted_5 = {
  key: 2,
  class: "flex ml-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12.0007 10.586L16.9507 5.63599L18.3647 7.04999L13.4147 12L18.3647 16.95L16.9507 18.364L12.0007 13.414L7.05072 18.364L5.63672 16.95L10.5867 12L5.63672 7.04999L7.05072 5.63599L12.0007 10.586Z",
  fill: "#373C49"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "content__body h-full" }
const _hoisted_9 = { class: "content__header" }
const _hoisted_10 = {
  key: 1,
  class: "header__title"
}
const _hoisted_11 = { class: "content__body py-8 px-6 justify-self-start" }
const _hoisted_12 = { class: "content__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cargo_status = _resolveComponent("cargo-status")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["ModalPanel__content", { 'justify-between': !_ctx.withoutFooter }]),
      style: _normalizeStyle({ maxWidth: _ctx.maxWidth, width: _ctx.width })
    }, [
      (_ctx.withoutFooter)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (Boolean(_ctx.titleTo))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "text-blue-500 underline font-semibold",
                      to: _ctx.titleTo
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.title), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.title), 1)),
                (_ctx.isTakes && _ctx.takesStatus)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_cargo_status, { status: _ctx.takesStatus }, null, 8, ["status"])
                    ]))
                  : (_ctx.cheapText)
                    ? (_openBlock(), _createBlock(_component_cheap, {
                        key: 3,
                        class: _normalizeClass(["ml-3 small font-bold", _ctx.cheapClass])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.cheapText), 1)
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
              ]),
              (_openBlock(), _createElementBlock("svg", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitCancel && _ctx.emitCancel(...args))),
                class: "cursor-pointer",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, _hoisted_7))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                (Boolean(_ctx.titleTo))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "text-blue-500 underline font-semibold",
                      to: _ctx.titleTo
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.title), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.title), 1)),
                _createElementVNode("i", {
                  class: "fas fa-times fa-sm header__icon",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitCancel && _ctx.emitCancel(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_new_button, {
                class: _normalizeClass(_ctx.confirmButtonClass),
                disabled: _ctx.confirmDisabled,
                onClick: _ctx.emitSubmit,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.confirmButtonText), 1)
                ]),
                _: 1
              }, 8, ["class", "disabled", "onClick", "loading"])
            ])
          ], 64))
    ], 6),
    _createElementVNode("div", {
      class: "opacity-50 fixed inset-0 z-40",
      style: {"background-color":"#051761"},
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitCancel && _ctx.emitCancel(...args)))
    })
  ]))
}